import { render, staticRenderFns } from "./PayPalBalance.vue?vue&type=template&id=9f9dfe38&scoped=true"
import script from "./PayPalBalance.vue?vue&type=script&lang=js"
export * from "./PayPalBalance.vue?vue&type=script&lang=js"
import style0 from "./PayPalBalance.vue?vue&type=style&index=0&id=9f9dfe38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9dfe38",
  null
  
)

export default component.exports